// extracted by mini-css-extract-plugin
export default {"root":"TitledListItem_root__ribo5","grouped":"TitledListItem_grouped__TFbJO","title":"TitledListItem_title__K4a2I","description":"TitledListItem_description__VxYKl"};